import { render, staticRenderFns } from "./ListRelease.vue?vue&type=template&id=3f20a08b&"
import script from "./ListRelease.vue?vue&type=script&lang=js&"
export * from "./ListRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListRelease.vue"
export default component.exports